import { setPaymentCheckFailed, setPaymentSuccessInfo } from './paymentSlice'

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level
export const checkTaxPaymentAsync = (paymentID, completionCallback = () => null) => {
    return async (dispatch, getState, api) => {
        try {
            const data = await api.checkTaxPayment(getState(), paymentID);
            dispatch(setPaymentSuccessInfo(data));
        } catch (error) {
            dispatch(setPaymentCheckFailed(true));
        }
        finally {
            completionCallback();
        }
    }
}

export const checkApplicationPaymentAsync = (paymentID, completionCallback = () => null) => {
    return async (dispatch, getState, api) => {
        try {
            const data = await api.checkLicensePayment(getState(), paymentID);
            dispatch(setPaymentSuccessInfo(data));
        } catch (error) {
            dispatch(setPaymentCheckFailed(true));
        } finally {
            completionCallback();
        }
    }
}

export const payNothing = (emailAddress, onCompletionCallback) => {
    return async (dispatch, getState, api) => {
        let outcome = {
            success: false,
            id: '',
            paymentId: '',
            paymentConfirmation: ''
        }
        try {
            const { paymentID, signatoryName } = getState()?.payment;
            const { paymentId } = await api.payNothing(getState(), paymentID, signatoryName, emailAddress);
            if (paymentId) {
                const data = await api.checkLicensePayment(getState(), paymentId);
                const { id, paymentConfirmation } = data;
                dispatch(setPaymentSuccessInfo(data));
                if (id !== undefined && paymentConfirmation !== undefined) {
                    outcome.success = true;
                    outcome.paymentId = paymentId;
                    outcome.id = id;
                    outcome.paymentConfirmation = paymentConfirmation;
                }
            } 
            onCompletionCallback(outcome);
        } catch (error) {
            onCompletionCallback(outcome);
        } 

    }   
}


export const payNothingTax = (emailAddress, onCompletionCallback) => {
    return async (dispatch, getState, api) => {
        try {
            const { paymentID, signatoryName } = getState()?.payment;
            const { paymentId } = await api.payNothingGeneric(getState(), paymentID, signatoryName, emailAddress);
            if(paymentId){
                dispatch(checkTaxPaymentAsync(paymentID, onCompletionCallback(true)));   
            }
            else{
                onCompletionCallback(false);
            }
        } catch (error) {
            onCompletionCallback(false);
        } 
    }   
}


export const payNothingRenewal = (emailAddress, onCompletionCallback) => {
    return async (dispatch, getState, api) => {
        try {
            const { paymentID, signatoryName } = getState()?.payment;
            const { paymentId } = await api.payNothingGeneric(getState(), paymentID, signatoryName, emailAddress);
            if(paymentId){
                dispatch(checkApplicationPaymentAsync(paymentID, onCompletionCallback(true)));   
            }
            else{
                onCompletionCallback(false);
            }
        } catch (error) {
            onCompletionCallback(false);
        } 
    }   
}